import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/Floating";
import { ChatWidget } from "@/components/ChatWidget";
import { CodeSlot } from "@/components/CodeSlot";
import { DecorLayer } from "@/components/decor/DecorLayer";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#contenido" className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-3 focus:bg-gold focus:text-black">Saltar al contenido</a>
      <Header />
      <main id="contenido" className="flex-1"><CodeSlot position="top" /><Outlet /><CodeSlot position="bottom" /></main>
      <Footer />
      <FloatingWhatsApp />
      <ChatWidget />
      <DecorLayer />
    </div>
  );
}
